import type { MessengerFeatureConfig } from '../type';

export const messenger: Partial<MessengerFeatureConfig> = {
    extendedAllowedAttachmentExtensions: ['ppt', 'pptx'],
};
